import React, {useState} from "react";
import {Button, Col, DatePicker, Form, Input, Row, Select} from "antd";
import PropTypes from "prop-types";

import {getActiveAccount} from "../../lib/activeMember";
import {dateFormat} from "../../lib/time";
import {createPayment} from "../../helpers/billing";
import {messageType, showMessages} from "../../helpers/message";
import InputMoney from "./InputMoney";
import {formInCardLayout, formItemFullWidth} from "../../assets/styles";
import {createPaymentRecord, createRefundRecord, loadAccountInfoErrorText, greaterThanZero} from "../../helpers/text";

const {Option} = Select;

const PaymentCreateForm = (props) => {
    const [loading, setLoading] = useState(false);

    // region form functions
    const [form] = Form.useForm();

    const handleFinish = async (values) => {
        // Set the sign of the amount based on the payment prop
        const sign = (props.paymentType === 'refund') ? -1 : 1;
        const amount = Math.abs(values['Amount']) * sign;
        const paidAt = values['Date'].format('YYYY-MM-DD HH:mm:ssZZ');
        const reference = values['Reference Number'];
        const method = values['Payment Method'];
        const data = {amount, paidAt, reference, method};

        try {
            setLoading(true);
            const account = getActiveAccount();
            if (account === null) {
                throw new Error(loadAccountInfoErrorText);
            }

            await createPayment(account.id, data, null);
            showMessages('The amount has been applied and is now reflected in the account balance.',
                messageType.success);
            setLoading(false);
            form.resetFields();

            props.toggleRefreshBalances(true);
        } catch (error) {
            showMessages(error.message, messageType.error);
            setLoading(false);
        }
    };

    return (
        <Form
            form={form}
            layout="vertical"
            name="payment-create"
            onFinish={handleFinish}
            {...formInCardLayout}
        >
            {(props.paymentType === 'refund') ? createRefundRecord : createPaymentRecord}
            <Row>
                <Col xs={24} lg={12}>
                    <Form.Item
                      name="Date"
                      label="Date"
                      rules={[{type: 'object', required: true}]}
                    >
                        <DatePicker
                          placeholder="DD MM YYYY"
                          format={dateFormat}
                          style={{...formItemFullWidth}}
                        />
                    </Form.Item>
                </Col>
            </Row>
            <Form.Item
                name="Payment Method"
                label="Payment Method"
                rules={[{type: 'string', required: true}]}
            >
                <Select>
                    <Option value="cash">Cash</Option>
                    <Option value="cheque">Cheque</Option>
                    <Option value="debit card">Debit card</Option>
                    <Option value="credit card">Credit card</Option>
                </Select>
            </Form.Item>
            <Form.Item
                name="Reference Number"
                label="Reference Number"
                rules={[{type: 'string', required: true}]}
            >
                <Input name="reference"/>
            </Form.Item>
            <Form.Item
                name="Amount"
                label="Amount"
                rules={[{type: 'number', required: true, min: 0.01}]}
                help={greaterThanZero}
            >
                <InputMoney />
            </Form.Item>
            <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading}>
                    Apply to Account
                </Button>
            </Form.Item>
        </Form>
    );
}

export default PaymentCreateForm;

PaymentCreateForm.propTypes = {
    paymentType: PropTypes.string.isRequired,
    toggleRefreshBalances: PropTypes.func.isRequired,
};
